module.exports = __webpack_public_path__ + "img/hic-skin-connective-and-musculoskeletal-diseases-female.240ab40f.png";